import React from "react"
import Index from '../components/Pages/Index'

const IndexPage = () => (
  <Index locale='en' />
)

export default IndexPage
